import {
  Accordion,
  AccordionDetails,
  AccordionProps,
  Fade,
  FormControlLabel,
  Grid,
  Typography,
} from "@material-ui/core";
import { useStyles } from "./accordion-saurus-styles";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import { ExpandBoldRoundIcon, ExpandIcon } from "views/components/icons";
import { useCallback } from "react";
import classNames from "classnames";
interface AccordionSaurusProps extends AccordionProps {
  tituloChildren?: React.ReactNode;
  expandChildren?: React.ReactNode;
  labelPrimary?: React.ReactNode;
  labelSecondary?: React.ReactNode;
  colorDivider?: string;
  heightDivider?: number;
  noIconRotation?: boolean;
  noPaperRoot?: boolean;
  noPaddingContent?: boolean;
  tipoExpand?: "padrao" | "bold";
  colorExpand?: string;
  expandSize?: number;
  showDivider?: boolean
  occultExpandIcon?: boolean
  removeMarginExpanded?: boolean
  removePaddingContainerTitle?: boolean
  classesTitle?: string
}

export const AccordionSaurus = ({
  tituloChildren,
  expandChildren,
  labelPrimary,
  labelSecondary,
  colorDivider,
  showDivider,
  heightDivider,
  noPaperRoot,
  noPaddingContent,
  tipoExpand,
  colorExpand,
  expandSize,
  occultExpandIcon,
  removeMarginExpanded,
  removePaddingContainerTitle,
  ...props
}: AccordionSaurusProps) => {
  const classes = useStyles();

  const selectExpand = useCallback(() => {
    switch (tipoExpand) {
      case "bold":
        return (
          <ExpandBoldRoundIcon
            style={{ width: 25, height: 25, fill: colorExpand ?? undefined }}
          />
        );
      default:
        return (
          <ExpandIcon
            style={{ width: 25, height: 25, fill: colorExpand ?? undefined }}
          />
        );
    }
  }, [tipoExpand, colorExpand]);


  return (
    <>
      <Accordion
        {...props}
        classes={{
          root: classNames(noPaperRoot
            ? classes.rootAccordionNoPaper
            : classes.rootAccordion,
            classes.iconWithoutRotation
          ),
          expanded: classNames(classes.expanded, removeMarginExpanded ? classes.removeMarginExpanded : undefined),
        }}
      >
        <AccordionSummary
          classes={{
            root: noPaddingContent
              ? classes.accordionContentNoPadding
              : classes.accordionContent,
            content: noPaddingContent
              ? classes.accordionSumaryContentNoPadding
              : classes.accordionSumaryContent,
          }}
          expandIcon={occultExpandIcon ? <></> : expandChildren ? <>{expandChildren}</> : <>{selectExpand()}</>}
        >
          <Grid container spacing={2}>
            <Grid
              className={classNames(removePaddingContainerTitle ? classes.containerTitleNoPadding : classes.containerTitle)}
              style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              {tituloChildren && <>{tituloChildren}</>}
              {labelPrimary && (
                <Typography display="inline" className={classNames(classes.title, props.classesTitle)}>
                  {labelPrimary}
                </Typography>
              )}
              {labelSecondary}
            </Grid>
            <FormControlLabel
              onClick={(event) => event.stopPropagation()}
              onFocus={(event) => event.stopPropagation()}
              label=""
              control={<></>}
            />
          </Grid>
        </AccordionSummary>
        {showDivider && (
          <Fade in timeout={2000}>
            <Grid xs={12} style={{ padding: '0px 16px', marginTop: '-22px' }}>
              <div className={classes.divider} />
            </Grid>
          </Fade>
        )}
        <AccordionDetails
          classes={{
            root: noPaddingContent
              ? classes.accordionContentNoPadding
              : classes.accordionContent,
          }}
        >
          {props.children}
        </AccordionDetails>
      </Accordion>
    </>
  );
};
